/**
 * 🐋 Species Data - Cetalingua FM
 * 88 marine mammal species (IDs 1-88)
 */

export const SPECIES_DATA = {
  1: { name: "West Indian Manatee", scientific: "Trichechus manatus", category: "manatee" },
  2: { name: "Amazonian Manatee", scientific: "Trichechus inunguis", category: "manatee" },
  3: { name: "West African Manatee", scientific: "Trichechus senegalensis", category: "manatee" },
  4: { name: "Dugong", scientific: "Dugong dugon", category: "manatee" },
  5: { name: "North Atlantic Right Whale", scientific: "Eubalaena glacialis", category: "whale" },
  6: { name: "North Pacific Right Whale", scientific: "Eubalaena japonica", category: "whale" },
  7: { name: "Southern Right Whale", scientific: "Eubalaena australis", category: "whale" },
  8: { name: "Bowhead Whale", scientific: "Balaena mysticetus", category: "whale" },
  9: { name: "Pygmy Right Whale", scientific: "Caperea marginata", category: "whale" },
  10: { name: "Gray Whale", scientific: "Eschrichtius robustus", category: "whale" },
  11: { name: "Humpback Whale", scientific: "Megaptera novaeangliae", category: "whale" },
  12: { name: "Minke Whale", scientific: "Balaenoptera acutorostrata", category: "whale" },
  13: { name: "Dwarf Minke Whale", scientific: "Balaenoptera acutorostrata subspecies", category: "whale" },
  14: { name: "Antarctic Minke Whale", scientific: "Balaenoptera bonaerensis", category: "whale" },
  15: { name: "Bryde's Whale", scientific: "Balaenoptera edeni", category: "whale" },
  16: { name: "Sei Whale", scientific: "Balaenoptera borealis", category: "whale" },
  17: { name: "Fin Whale", scientific: "Balaenoptera physalus", category: "whale" },
  18: { name: "Blue Whale", scientific: "Balaenoptera musculus", category: "whale" },
  19: { name: "Sperm Whale", scientific: "Physeter macrocephalus", category: "whale" },
  20: { name: "Pygmy Sperm Whale", scientific: "Kogia breviceps", category: "whale" },
  21: { name: "Dwarf Sperm Whale", scientific: "Kogia sima", category: "whale" },
  22: { name: "Beluga Whale", scientific: "Delphinapterus leucas", category: "whale" },
  23: { name: "Narwhal", scientific: "Monodon monoceros", category: "whale" },
  24: { name: "Cuvier's Beaked Whale", scientific: "Ziphius cavirostris", category: "whale" },
  25: { name: "Arnoux's Beaked Whale", scientific: "Berardius arnuxii", category: "whale" },
  26: { name: "Baird's Beaked Whale", scientific: "Berardius bairdii", category: "whale" },
  27: { name: "Shepherd's Beaked Whale", scientific: "Tasmacetus shepherdi", category: "whale" },
  28: { name: "Longman's Beaked Whale", scientific: "Indopacetus pacificus", category: "whale" },
  29: { name: "Northern Bottlenose Whale", scientific: "Hyperoodon ampullatus", category: "whale" },
  30: { name: "Southern Bottlenose Whale", scientific: "Hyperoodon planifrons", category: "whale" },
  31: { name: "Hector's Beaked Whale", scientific: "Mesoplodon hectori", category: "whale" },
  32: { name: "True's Beaked Whale", scientific: "Mesoplodon mirus", category: "whale" },
  33: { name: "Gervais' Beaked Whale", scientific: "Mesoplodon europaeus", category: "whale" },
  34: { name: "Sowerby's Beaked Whale", scientific: "Mesoplodon bidens", category: "whale" },
  35: { name: "Gray's Beaked Whale", scientific: "Mesoplodon grayi", category: "whale" },
  36: { name: "Pygmy Beaked Whale", scientific: "Mesoplodon peruvianus", category: "whale" },
  37: { name: "Andrews' Beaked Whale", scientific: "Mesoplodon bowdoini", category: "whale" },
  38: { name: "Hubbs' Beaked Whale", scientific: "Mesoplodon carlhubbsi", category: "whale" },
  39: { name: "Ginkgo-toothed Beaked Whale", scientific: "Mesoplodon ginkgodens", category: "whale" },
  40: { name: "Strap-toothed Beaked Whale", scientific: "Mesoplodon layardii", category: "whale" },
  41: { name: "Blainville's Beaked Whale", scientific: "Mesoplodon densirostris", category: "whale" },
  42: { name: "Stejneger's Beaked Whale", scientific: "Mesoplodon stejnegeri", category: "whale" },
  43: { name: "Amazon River Dolphin", scientific: "Inia geoffrensis", category: "dolphin" },
  44: { name: "Franciscana", scientific: "Pontoporia blainvillei", category: "dolphin" },
  45: { name: "Ganges & Indus River Dolphin", scientific: "Platanista gangetica", category: "dolphin" },
  46: { name: "Bottlenose Dolphin", scientific: "Tursiops truncatus", category: "dolphin" },
  47: { name: "Chilean Dolphin", scientific: "Cephalorhynchus eutropia", category: "dolphin" },
  48: { name: "Commerson's Dolphin", scientific: "Cephalorhynchus commersonii", category: "dolphin" },
  49: { name: "Heaviside's Dolphin", scientific: "Cephalorhynchus heavisidii", category: "dolphin" },
  50: { name: "Hector's Dolphin", scientific: "Cephalorhynchus hectori", category: "dolphin" },
  51: { name: "Rough-toothed Dolphin", scientific: "Steno bredanensis", category: "dolphin" },
  52: { name: "Atlantic Humpback Dolphin", scientific: "Sousa teuszii", category: "dolphin" },
  53: { name: "Indo-Pacific Humpback Dolphin", scientific: "Sousa chinensis", category: "dolphin" },
  54: { name: "Tucuxi", scientific: "Sotalia fluviatilis", category: "dolphin" },
  55: { name: "Indo-Pacific Bottlenose Dolphin", scientific: "Tursiops aduncus", category: "dolphin" },
  56: { name: "Pantropical Spotted Dolphin", scientific: "Stenella attenuata", category: "dolphin" },
  57: { name: "Atlantic Spotted Dolphin", scientific: "Stenella frontalis", category: "dolphin" },
  58: { name: "Spinner Dolphin", scientific: "Stenella longirostris", category: "dolphin" },
  59: { name: "Clymene Dolphin", scientific: "Stenella clymene", category: "dolphin" },
  60: { name: "Striped Dolphin", scientific: "Stenella coeruleoalba", category: "dolphin" },
  61: { name: "Short-beaked Common Dolphin", scientific: "Delphinus delphis", category: "dolphin" },
  62: { name: "Fraser's Dolphin", scientific: "Lagenodelphis hosei", category: "dolphin" },
  63: { name: "Long-beaked Common Dolphin", scientific: "Delphinus capensis", category: "dolphin" },
  64: { name: "White-beaked Dolphin", scientific: "Lagenorhynchus albirostris", category: "dolphin" },
  65: { name: "Atlantic White-sided Dolphin", scientific: "Leucopleurus acutus", category: "dolphin" },
  66: { name: "Pacific White-sided Dolphin", scientific: "Lagenorhynchus obliquidens", category: "dolphin" },
  67: { name: "Dusky Dolphin", scientific: "Lagenorhynchus obscurus", category: "dolphin" },
  68: { name: "Peale's Dolphin", scientific: "Lagenorhynchus australis", category: "dolphin" },
  69: { name: "Hourglass Dolphin", scientific: "Lagenorhynchus cruciger", category: "dolphin" },
  70: { name: "Northern Right Whale Dolphin", scientific: "Lissodelphis borealis", category: "dolphin" },
  71: { name: "Southern Right Whale Dolphin", scientific: "Lissodelphis peronii", category: "dolphin" },
  72: { name: "Risso's Dolphin", scientific: "Grampus griseus", category: "dolphin" },
  73: { name: "Melon-headed Whale", scientific: "Peponocephala electra", category: "dolphin" },
  74: { name: "Pygmy Killer Whale", scientific: "Feresa attenuata", category: "dolphin" },
  75: { name: "False Killer Whale", scientific: "Pseudorca crassidens", category: "dolphin" },
  76: { name: "Killer Whale / Orca", scientific: "Orcinus orca", category: "dolphin" },
  77: { name: "Long-finned Pilot Whale", scientific: "Globicephala melas", category: "dolphin" },
  78: { name: "Short-finned Pilot Whale", scientific: "Globicephala macrorhynchus", category: "dolphin" },
  79: { name: "Irrawaddy Dolphin", scientific: "Orcaella brevirostris", category: "dolphin" },
  80: { name: "Finless Porpoise", scientific: "Neophocaena phocaenoides", category: "porpoise" },
  81: { name: "Harbour Porpoise", scientific: "Phocoena phocoena", category: "porpoise" },
  82: { name: "Burmeister's Porpoise", scientific: "Phocoena spinipinnis", category: "porpoise" },
  83: { name: "Spectacled Porpoise", scientific: "Phocoena dioptrica", category: "porpoise" },
  84: { name: "Dall's Porpoise", scientific: "Phocoenoides dalli", category: "porpoise" },
  85: { name: "Vaquita", scientific: "Phocoena sinus", category: "porpoise" },
  86: { name: "Unidentified Whale", scientific: "Whale spp.", category: "unknown" },
  87: { name: "Unidentified Dolphin", scientific: "Dolphin spp.", category: "unknown" },
  88: { name: "Unidentified Porpoise", scientific: "Porpoise spp.", category: "unknown" },
};

// Get all species as array
export const getSpeciesArray = () => {
  return Object.entries(SPECIES_DATA).map(([id, data]) => ({
    id: parseInt(id),
    ...data
  }));
};

// Get species by category
export const getSpeciesByCategory = (category) => {
  return getSpeciesArray().filter(s => s.category === category);
};

// Get species name by ID
export const getSpeciesName = (id) => {
  return SPECIES_DATA[id]?.name || 'Unknown';
};

// Get species by ID
export const getSpeciesById = (id) => {
  return SPECIES_DATA[id] || null;
};

export default SPECIES_DATA;
